import React from 'react';

export function UnsubIcon(): JSX.Element {
  return (
    <svg fill='none' height='40' viewBox='0 0 40 40' width='40' xmlns='http://www.w3.org/2000/svg'>
      <rect fill='#ECF8FB' height='40' rx='8' width='40' />
      <path
        clipRule='evenodd'
        d='M14.1663 13.1667C13.9011 13.1667 13.6468 13.272 13.4592 13.4596C13.2717 13.6471 13.1663 13.9015 13.1663 14.1667V25.8333C13.1663 26.0986 13.2717 26.3529 13.4592 26.5404C13.6468 26.728 13.9011 26.8333 14.1663 26.8333H17.4997C17.8679 26.8333 18.1663 27.1318 18.1663 27.5C18.1663 27.8682 17.8679 28.1667 17.4997 28.1667H14.1663C13.5475 28.1667 12.954 27.9208 12.5164 27.4833C12.0788 27.0457 11.833 26.4522 11.833 25.8333V14.1667C11.833 13.5478 12.0788 12.9543 12.5164 12.5168C12.954 12.0792 13.5475 11.8333 14.1663 11.8333H17.4997C17.8679 11.8333 18.1663 12.1318 18.1663 12.5C18.1663 12.8682 17.8679 13.1667 17.4997 13.1667H14.1663Z'
        fill='#10ADCF'
        fillRule='evenodd'
      />
      <path
        clipRule='evenodd'
        d='M22.8616 15.3619C23.122 15.1016 23.5441 15.1016 23.8044 15.3619L27.9711 19.5286C28.2314 19.789 28.2314 20.2111 27.9711 20.4714L23.8044 24.6381C23.5441 24.8984 23.122 24.8984 22.8616 24.6381C22.6013 24.3777 22.6013 23.9556 22.8616 23.6953L26.5569 20L22.8616 16.3047C22.6013 16.0444 22.6013 15.6223 22.8616 15.3619Z'
        fill='#10ADCF'
        fillRule='evenodd'
      />
      <path
        clipRule='evenodd'
        d='M16.833 20C16.833 19.6318 17.1315 19.3333 17.4997 19.3333H27.4997C27.8679 19.3333 28.1663 19.6318 28.1663 20C28.1663 20.3682 27.8679 20.6667 27.4997 20.6667H17.4997C17.1315 20.6667 16.833 20.3682 16.833 20Z'
        fill='#10ADCF'
        fillRule='evenodd'
      />
    </svg>
  );
}
